<div class="modal-header">
  <h2 i18n="@@payment_info.add_payment_information">Add Payment Information</h2>
  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="activeModal.dismiss()">
      <svg version="1.1" x="0px" y="0px" width="14" height="14"  viewBox="0 0 14 14">
          <path class="icon-stroke" fill="none" stroke-width="2" stroke-linecap="square" d="M2.8,11.2l8.5-8.5 M2.8,2.8l8.5,8.5"/>
      </svg>
  </button>
</div>

<div class="modal-body">
  <div class="label-bar" i18n="@@payment_info.payment_made_to">Payment to be made to</div>
  <form [formGroup]="paymentForm" (ngSubmit)="paymentForm.valid && submit()" class="invoice-terms-form" #docPaymentForm="ngForm">
      
      <fieldset class="no-label" [ngClass]="{'has-error': submitted && paymentForm.controls.name.errors && paymentForm.controls.name.errors.required}">
        <div role="fieldgroup">
          <label for="name" i18n="@@payment_info.user_name">Name</label>
          <input type="text" id="name" name="name" formControlName="name" />
          <span class="field-error" i18n="@@error.required">* Required</span>
        </div>
      </fieldset>
      
      <fieldset class="no-label" [ngClass]="{'has-error': submitted && paymentForm.controls.iban.errors && paymentForm.controls.iban.errors.required}">
        <div role="fieldgroup">
          <label for="iban" i18n="@@payment_info.iban">IBAN</label>
          <input type="text" id="iban" name="iban" formControlName="iban"  />
          <span class="field-error" i18n="@@error.required">* Required</span>
        </div>
      </fieldset>
      
      <fieldset class="no-label" [ngClass]="{'has-error': submitted && paymentForm.controls.account_number.errors && paymentForm.controls.account_number.errors.required}">
        <div role="fieldgroup">
          <label for="account_number" i18n="@@payment_info.account_number">Account number</label>
          <input type="text" id="account_number" name="account_number" formControlName="account_number"  />
          <span class="field-error" i18n="@@error.required">* Required</span>
        </div>
      </fieldset>

      <fieldset class="no-label" [ngClass]="{'has-error': submitted && paymentForm.controls.bank_name.errors && paymentForm.controls.bank_name.errors.required}">
        <div role="fieldgroup">
          <label for="bank_name" i18n="@@payment_info.bank_name">Bank Name</label>
          <input type="text" id="bank_name" name="bank_name" formControlName="bank_name"  />
          <span class="field-error" i18n="@@error.required">* Required</span>
        </div>
      </fieldset>

      <fieldset class="no-label" [ngClass]="{'has-error': submitted && paymentForm.controls.country.errors && paymentForm.controls.country.errors.required}">
        <div role="fieldgroup">
          <label for="country" i18n="@@payment_info.country">Country</label>
          <input type="text" id="country" name="country" formControlName="country"  />
          <span class="field-error" i18n="@@error.required">* Required</span>
        </div>
      </fieldset>

  </form>
</div>

<div class="modal-footer">
  <button type="button" (click)="submitted=true; submitType='proposal';docPaymentForm.ngSubmit.emit()" class="tu-btn pink" i18n="@@button.save_for_invoice">Save for this proposal</button>
  <button type="button" (click)="submitted=true; submitType='default';docPaymentForm.ngSubmit.emit()" class="tu-btn blue" i18n="@@button.save_as_default">Save as default</button>
</div>
